// extracted by mini-css-extract-plugin
export default {"facetMenu":"Cz-z","fixed":"Dz-z","nonLayerdFacets":"Ez-z","productCount":"Fz-z","facetBack":"Gz-z","arrow":"Hz-z","facetClose":"Iz-z"};